<template>
<div @click="$router.push({ name: card.route })" class="w-full xl:w-1/4 lg:w-1/3 sm:w-1/2 sm:p-2 px-2 cursor-pointer">
    <div class="rounded overflow-hidden w-full my-2 shadow-lg bg-white">
        <div class="p-4">
            <div class="program-main mb-2 tenant-main-color">
                {{ card.title }}
            </div>
            <p class="program-content text-gray-700 text-base">
                {{ card.description }}
            </p>
            <p class=" program-content flex tenant-main-color my-1 justify-start">
                <span class="font-bold">Open</span>
            </p>
            <p class=" program-content flex tenant-main-color my-2 justify-end">
                <img class="h-32" :src="card.image" alt="" />
            </p>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ["card"],
};
</script>

<style lang="css" scoped>
.program-main {
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
}

.program-content {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
}
</style>
